import { Pad } from 'component/basics';
import { InformationalModal } from 'component/modal/informational-modal';
import { ProfilePhotoImage } from 'component/people';
import { UtilityText } from 'component/text';
import { getRoleLabel } from 'feature/feature-roles';
import { Pressable, StyleSheet, View } from 'react-native';
import { t } from 'util/stdtypes';

import type { DevLoginPersona } from './dev-login-personas';

export function DevLoginModal({
    personas,
    onClose,
    onSelectPersona,
}: {
    personas: DevLoginPersona[];
    onClose: () => void;
    onSelectPersona: (personaKey: string) => void;
}) {
    return (
        <InformationalModal
            content={
                <View style={DevLoginModalStyle.personaList}>
                    {personas.map((persona) => (
                        <Pressable
                            key={persona.profileKey}
                            onPress={() => onSelectPersona(persona.profileKey)}
                            style={DevLoginModalStyle.personaRow}
                        >
                            <ProfilePhotoImage profile={persona} type='small' />
                            <Pad size={12} />
                            {persona.role ? (
                                <UtilityText text={`${persona.name} (${getRoleLabel(persona.role).defaultText})`} weight='strong' />
                            ) : (
                                <UtilityText text={persona.name} />
                            )}
                        </Pressable>
                    ))}
                </View>
            }
            headingLabel={t('login.select_dev_persona', 'Select a dev persona')}
            onClose={onClose}
        />
    );
}

const DevLoginModalStyle = StyleSheet.create({
    personaList: {
        gap: 8,
    },
    personaRow: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: 8,
        paddingHorizontal: 12,
        borderRadius: 8,
    },
});
